module.exports = __webpack_public_path__ + "static/media/clue-1.f41456f4.svg";